// extracted by mini-css-extract-plugin
export var divider = "_sa-0";
export var systemMessage = "_sa-1";